// extracted by mini-css-extract-plugin
export default {"arrowMode":"ButtonNext_arrowMode__WCre1","squareMode":"ButtonNext_squareMode__8KMiL","buttonBase":"ButtonNext_buttonBase__IXOMs","arrowRight":"ButtonNext_arrowRight__0cOZ6"};